'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 10,
    bottom: 50,
    left: 85,
    right: 12
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 5,
    xAxisShift: 5,
    yAxisShift: 10,
    yAxisLabelShift: 70,
    xGapSize: 15,
    xDataSize: 40,
    xBarPadding: 2.5,
    isSparse: true,
    xAxisLabelShift: 32,
    xAxisLabelHorizontalShift: -(width / 2 + 35)
  };
};
module.exports = Params;